export default {
  'sendpasswordsuccessfully.and': 'И',
  'sendpasswordsuccessfully.successfully': 'Успешно',
  'sendpasswordsuccessfully.passwordsentto': 'Отправить ссылку для восстановления пароля на электронную почту ',
  'sendpasswordsuccessfully.checkemail':
    'Пожалуйста, проверьте свою электронную почту, чтобы сбросить пароль',
  'sendpasswordsuccessfully.sendpassword': 'пароль успешно отправлен',
};
